import styled from 'styled-components';

export const Container = styled.header`
  align-items: center;
  background-color: ${({ theme }) => theme.colors.primary.main};
  box-shadow:0 3px 4px 0 rgb(0 0 0 / 20%),
             0 3px 3px -2px rgb(0 0 0 / 14%),
              0 1px 8px 0 rgb(0 0 0 / 12%);
  display: flex;
  height: 56px;
  padding: 0 16px;
  width: 100%;
  position: sticky;
  top: 0;

  @media screen and (min-width: 540px){
    margin-bottom: 74px;
  }
`;

export const Leading = styled.button`
  height: 48px;
  width: 48px;
  background: ${({ theme }) => theme.colors.primary.main};
  border: none;
  outline: none;

`;

export const NavItem = styled.li`
  background-color: ${({ selected }) => (selected ? '#E4F0F6' : 'transparent')};
  border-radius: 4px;
  color:  ${({ theme, selected }) => (selected ? theme.colors.primary.main : theme.colors.gray['900'])};
  cursor: pointer;
  padding: 8px;
  min-height: 36px;
  list-style: none;

  ${({ theme, selected }) => !selected
    && `
    &:hover{
    background-color: ${theme.colors.gray['200']};
  }`}

  &+&{
    margin-top: 4px;
  }

  a{
      background-color: inherit;
      border-radius: inherit;
      color: inherit;
      display: flex;
      text-decoration: none;
      transition-property: background-color, border-color, box-shadow;
      transition-duration: 85ms;
      transition-timing-function: ease;
      width: 100%;
    }
`;

export const LogoutButton = styled.button`
  background-color: #fff;
  border:2px solid  ${({ theme }) => theme.colors.error};
  border-radius: 4px;
  color: ${({ theme }) => theme.colors.error};
  font-weight: bold;
  text-decoration: none;
  padding: 8px 16px;
  transition: all 0.2s ease-in;

  &:hover{
    background: ${({ theme }) => theme.colors.error};
    color: #fff;
  }
  min-height: 36px;
  outline: none;
`;

export const WorkspacesHeader = styled.header`
  align-items: center;
  color: ${({ theme }) => theme.colors.gray.oslo};
  display: flex;
  font-size: 14px;
  justify-content: space-between;
  margin-top: 24px;

  a{
    text-decoration: none;
    &:hover {
      border-radius: 4px;
      background-color: ${({ theme }) => theme.colors.gray['200']};
    }
  }
`;

export const WorkspaceItem = styled.li`
  list-style: none;
  a{
    text-decoration: none;
  }
`;
